// extracted by mini-css-extract-plugin
export var actionButton = "_fu-t";
export var buttonContainer = "_fu-0";
export var buttonContainer2 = "_fu-1";
export var buttonSection = "_fu-2";
export var details = "_fu-3";
export var dropdownItem = "_fu-5";
export var dropdownItemsContainer = "_fu-4";
export var fileInput = "_fu-r";
export var headerButton = "_fu-6";
export var icon = "_fu-7";
export var input = "_fu-8";
export var macroListItem = "_fu-9";
export var mainContent = "_fu-a";
export var microText = "_fu-b";
export var modal = "_fu-w";
export var optionsButton = "_fu-c";
export var paperclip = "_fu-s";
export var pillContent = "_fu-d";
export var preview = "_fu-e";
export var preview2 = "_fu-f";
export var quillEditor = "_fu-q";
export var selectedMacro = "_fu-g";
export var sidebar = "_fu-h";
export var sidebarHeader = "_fu-j";
export var sidebarList = "_fu-i";
export var sidebarListItem = "_fu-k";
export var sidebarSearch = "_fu-l";
export var snoozeDurationWrapper = "_fu-v";
export var statusPillContainer = "_fu-m";
export var tagsContainer = "_fu-n";
export var unselectedMacro = "_fu-o";
export var variable = "_fu-u";
export var wrapper = "_fu-p";